import isScriptLoaded from '~/utils/isScriptLoaded'

export default function (src: string): Promise<boolean> {
  return new Promise((resolve) => {
    if (isScriptLoaded(src)) {
      resolve(true)
    } else {
      const stripeScript = document.createElement('script')
      stripeScript.setAttribute('src', src)
      stripeScript.onload = () => {
        try {
          resolve(true)
        } catch (e) {
          resolve(false)
        }
      }
      document.head.appendChild(stripeScript)
    }
  })
}
